import { useEffect, useState } from "react";
import BeforeLoginMobile from "./BeforeLoginMobile";
import BeforeLoginWeb from "./BeforeLoginWeb";
import LeadCaptureModal from "../../components/Modals/LeadCaptureModal";

export default function BeforeLogin() {
  const [isMobile, setIsMobile] = useState(
    window.matchMedia("(max-width: 768px)").matches,
  );
  const [showModal, setShowModal] = useState(false);

  // Screen size listener
  useEffect(() => {
    const media = window.matchMedia("(max-width: 768px)");
    const handler = () => setIsMobile(media.matches);

    media.addEventListener("change", handler);
    return () => media.removeEventListener("change", handler);
  }, []);

  // Timer logic: Starts 30s timer when showModal is FALSE
  useEffect(() => {
    let timer;
    if (!showModal) {
      timer = setTimeout(() => {
        setShowModal(true);
      }, 10000); // Opens every 10 seconds after closing
    }

    return () => clearTimeout(timer); // Clean up on modal open or unmount
  }, [showModal]);

  const handleCloseModal = () => {
    setShowModal(false); // Closing this resets showModal, restarting the 30-second timer
  };

  return (
    <div
      style={{
        backgroundColor: "#f0f2f5",
        minHeight: "100vh",
        width: "100%",
        boxSizing: "border-box",
      }}
    >
      {isMobile ? <BeforeLoginMobile /> : <BeforeLoginWeb />}

      <LeadCaptureModal show={showModal} onHide={handleCloseModal} />
    </div>
  );
}
